var exports = {
  "SZ": "ShipFeedbackBanner__ib9bYR",
  "$9": "ShipFeedbackInline__7HOtov",
  "SK": "ShipFeedbackInlineIcon__It50ip",
  "c5": "PrivatePreview__iKm9mI",
  "Yz": "PrivatePreviewLink__NwpUf7",
};

module.exports = exports;
